import RestError from '../../modules/app/errors';

// eslint-disable-next-line import/prefer-default-export
export class SaveSlipConflictError extends RestError {
}
